import type { TextDirection } from "@yjsgames/i18n";

/**
 * N칸 세그먼트 레벨 바의 순수 좌표 로직 (Phaser 비의존 — 단위테스트 100% 커버).
 * 뷰(`SegmentLevelBar`)는 본 함수에 위임만 한다.
 *
 * 값 모델: 레벨 0~maxLevel(칸 수). level=n이면 n칸 채움.
 * RTL: 포인터 매핑은 오른쪽 끝=0·왼쪽 끝=maxLevel, 채움은 오른쪽 칸부터.
 */

/**
 * 바 내부 로컬 x(0~barWidth) → 0~maxLevel 정수 레벨. 비례 매핑 + 경계 clamp.
 * LTR: 왼쪽 끝=0, 오른쪽 끝=maxLevel. RTL: 오른쪽 끝=0, 왼쪽 끝=maxLevel(반전).
 */
export function levelFromLocalX(
  localX: number,
  barWidth: number,
  maxLevel: number,
  dir: TextDirection,
): number {
  if (barWidth <= 0) return 0;
  const ratio = dir === "rtl" ? (barWidth - localX) / barWidth : localX / barWidth;
  return clampLevel(Math.round(ratio * maxLevel), maxLevel);
}

/**
 * idx번째 칸(0-based, 항상 좌→우 순서로 생성됨)이 현재 level에서 채워지는지.
 * LTR: 왼쪽부터 채움(idx < level). RTL: 오른쪽부터 채움(idx >= maxLevel - level).
 */
export function segmentFilled(
  idx: number,
  level: number,
  maxLevel: number,
  dir: TextDirection,
): boolean {
  const lv = clampLevel(level, maxLevel);
  return dir === "rtl" ? idx >= maxLevel - lv : idx < lv;
}

/** 레벨 0~maxLevel clamp (NaN/음수/초과 방어). */
export function clampLevel(level: number, maxLevel: number): number {
  if (!Number.isFinite(level)) return 0;
  if (level < 0) return 0;
  if (level > maxLevel) return maxLevel;
  return level;
}
